import { HttpInterceptorFn } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { inject } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";

export const httpNativeInterceptor: HttpInterceptorFn = (req, next) => {
  const url =
    !req.url.includes(environment.domain) &&
    !req.url.includes("assets") &&
    !req.url.includes("http")
      ? `${environment.domain}${req.url}`
      : req.url;

  const oauthService = inject(OAuthService);
  const token = oauthService.getAccessToken();

  if (token && !req.url.includes("assets")) {
    return next(
      req.clone({
        url,
        setHeaders: { Authorization: `Bearer ${token}` },
      }),
    );
  }

  return next(req.clone({ url }));
};
